<template>
  <div v-show='listData'>
    <div class="home_item">
      <div class="home_item_title">
        <div class="cj_wrap">
          <img src="/static/images/icon_cj.png" class="icon_cj">
        </div>
        <div class="home_item_name">
          <p><span class="bold">{{pdata.title.substr(0,2)}}</span><span>{{pdata.title.substr(2)}}</span></p>
          <p class="title_en">{{pdata.info}}</p>
          <div class="dis dis-2"></div>
        </div>
         <div class="name-en" @click='loadMore'><img src="/static/images/mores.png"></div>
        <!-- <div class="name_en"><span>{{pdata.alias}}</span></div> -->
      </div>
      <div class="swiper-container" v-if="pdata.source.adsense.length > 0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in pdata.source.adsense">
            <a :href="item.href">
              <img :src="item.img">
            </a>
          </div>
        </div>
        <div class="swiper-button-prev" v-if="pdata.source.adsense.length > 1"></div>
        <div class="swiper-button-next" v-if="pdata.source.adsense.length > 1"></div>
      </div>
    </div>
    <pro-list :sdata="items" :isChangeList='isChangeList' :clear='clear' v-on:onData='onData'></pro-list>
  </div>
</template>
<script>
  import Swiper from '../../static/js/swiper.min.js'
  import proList from '../components/home_pro_list'

  export default {
    name: 'home',
    components: {
      proList
    },
    data () {
      return {
        msg: '首页',
        searchData: [],
        listData: true,
        pdata1: null,
        items: null,
        icon: 'https://act.mcake.com/fangli/2019/new-PC/wap/images/newyear-dis-' + (this.pindex + 1) + '.png'
      }
    },
    created () {
      this.items = this.pdata
    },
    mounted () {
      this.init()
    },
    activated () {
      this.init()
    },
    props: ['isChangeList', 'clear', 'pdata', 'obj', 'pindex'],
    watch: {
      isChangeList: {
        handler (newValue, oldValue) {
          if (this.isChangeList.num == 1) {
            return false
          }
          if (this.$route.path.includes('/home') || this.$route.path.includes('/list')) {
            //this.getBanner()
          }
        },
        deep: true
      }
    },
    methods: {
      onData (data) {
        this.listData = data

      },
      init () {
        if (this.pdata.source.adsense.length > 1) {
          this.$nextTick(function () {
            var proSwiper = new Swiper('.swiper-container', {
              loop: false,
              autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: true
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
            })
          })
        }
      },
      loadMore () {
        this.$router.push('/cake');
        if (this.leave) {
          return false
        }
        if (!this.isload) {
          return false
        }
        if (this.isloadAll) {
          return false
        }
        if (this.iswatch) {
          return false
        }
        if (this.loading) {
          return false
        }
        if (this.nomore) {
          return false
        }
        this.getList(1)
      },
    }
  }
</script>
<style scoped>
  @import '../../static/css/swiper.min.css';

  .home_item {
    text-align: left;
    
  }

  .no_border .home_item {
    border: none;
  }

  .icon_cj {
    width: 1.53rem;
  }

  .name_en {
    font-size: .266666666rem;
    color: #b2b2b2;
    flex: 1;
    text-align: right;
  }

  .name_en span {
    display: inline-block;
    margin-top: .2rem;
  }

  .cj_wrap {
    flex: 1;
  }

  .home_item_name {
    font-size: .4rem;
    color: #000;
    flex: 2
  }

  .home_item_name span:first-child {
    font-weight: bold;
  }

  .title_en {
    font-size: .18666666rem;
    color: #7f7f7f;
  }

  .home_item_title {
    padding: 1.2rem .6rem;
    display: flex;
  }

  .swiper_wrap {
    padding-left: .26666666rem;
    height: 3.86666666rem;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    display: flex;
  }

  .swiper_wrap img {
    height: 100%;
    width: auto;
    display: block;
  }

  .home_item .swiper-container {
    position: relative;
  }

  .home_item .swiper-container .swiper-button-prev {
    background-image: url(/static/images/swiper_left.png);
    background-size: .51rem;
  }

  .home_item .swiper-container .swiper-button-next {
    background-image: url(/static/images/swiper_right.png);
    background-size: .51rem;
  }

  .home_item_name {
    position: relative;
  }

  .dis {
    position: absolute;
    top: 0;
    left: 1.8rem;
    width: 0.7rem;
  }

  .home_item_name{position: relative;}
  .dis{position: absolute; top: 0; left: 1.8rem; width: 0.7rem;}
  .name-en{width: 2rem; height: 1rem; line-height: 1rem;}
</style>



// WEBPACK FOOTER //
// src/components/home-item.vue